export const canNavigateBack = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const historyIndex = window.history?.state?.idx;

  if (typeof historyIndex === 'number') {
    return historyIndex > 0;
  }

  return window.history.length > 1;
};

export const navigateBackWithFallback = (navigate, fallbackPath) => {
  if (canNavigateBack()) {
    navigate(-1);
    return;
  }

  if (fallbackPath) {
    navigate(fallbackPath);
  }
};
